module.exports = "/assets/listing/ginweekBannerDesktop.jpg?ytHhWIa";